import { Form } from 'formik';
import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal, PoolModalActions, PoolModalContent, PoolModalTitle } from '@synergy/components-next';
import { ReactElement } from 'react';

import { ChangePasswordContent } from './change-password-content';
import { changePasswordSelector } from '../../../store/change-password-selectors';
import { useAppSelector } from '../../../../store/store';

export const ChangePasswordModal = ({ onClose }: { onClose: () => void }): ReactElement | null => {
    const { isOpen } = useAppSelector(changePasswordSelector);

    return (
        <PoolModal open={isOpen} onClose={onClose}>
            <Form noValidate={true}>
                <PoolModalTitle>
                    <FormattedMessage id="app.changePassword" />
                </PoolModalTitle>
                <PoolModalContent>
                    <ChangePasswordContent />
                </PoolModalContent>
                <PoolModalActions>
                    <PoolButton variant="outlined" onClick={onClose}>
                        <FormattedMessage id="app.common.cancel" />
                    </PoolButton>
                    <PoolButton type="submit">
                        <FormattedMessage id="app.changePassword" />
                    </PoolButton>
                </PoolModalActions>
            </Form>
        </PoolModal>
    );
};
